<app-megamenu></app-megamenu>

<div class="service-page">
  <!-- Hero Section -->
  <div class="hero-section">
    <div class="hero-background"></div>
    <div class="container">
      <div class="hero-content">
        <h1>Ant Control Services</h1>
        <p class="hero-subtitle">Professional ant elimination and prevention services. We target the colony, not just the ants you see, for long-lasting results.</p>
        <div class="hero-actions">
          <button mat-raised-button class="cta-button" (click)="navigateToContact()">
            <mat-icon>pest_control</mat-icon>
            Get Ant Control
          </button>
          <button mat-button class="phone-button" (click)="callPhone()">
            <mat-icon>phone</mat-icon>
            Call {{ config.phone.display }}
          </button>
        </div>
      </div>
    </div>
  </div>

  <!-- Ant Types Section -->
  <div class="ant-types-section">
    <div class="container">
      <h2>Common Ant Species We Control</h2>
      <p class="section-subtitle">Different ant species require different treatment approaches - we identify and target each type effectively</p>
      
      <div class="ant-types-grid">
        <div *ngFor="let ant of antTypes" class="ant-card">
          <div class="ant-header">
            <h3>{{ ant.name }}</h3>
            <span class="severity-badge" [style.background-color]="getSeverityColor(ant.severity)">
              {{ ant.severity }} Risk
            </span>
          </div>
          <p>{{ ant.description }}</p>
        </div>
      </div>
    </div>
  </div>

  <!-- Treatment Methods Section -->
  <div class="treatment-section">
    <div class="container">
      <h2>Our Ant Control Methods</h2>
      <p class="section-subtitle">Comprehensive treatment strategies designed to eliminate entire ant colonies</p>
      
      <div class="treatment-grid">
        <div *ngFor="let treatment of treatmentMethods" class="treatment-card">
          <mat-icon>science</mat-icon>
          <h3>{{ treatment.method }}</h3>
          <p>{{ treatment.description }}</p>
        </div>
      </div>
    </div>
  </div>

  <!-- Process Section -->
  <div class="process-section">
    <div class="container">
      <h2>Our Ant Control Process</h2>
      
      <div class="process-steps">
        <div class="step">
          <div class="step-number">1</div>
          <div class="step-content">
            <h3>Inspection</h3>
            <p>Identify ant species, locate trails, and find nesting sites</p>
          </div>
        </div>
        
        <div class="step">
          <div class="step-number">2</div>
          <div class="step-content">
            <h3>Treatment Plan</h3>
            <p>Develop targeted strategy based on ant species and infestation level</p>
          </div>
        </div>
        
        <div class="step">
          <div class="step-number">3</div>
          <div class="step-content">
            <h3>Application</h3>
            <p>Apply baits and treatments to eliminate colonies at the source</p>
          </div>
        </div>
        
        <div class="step">
          <div class="step-number">4</div>
          <div class="step-content">
            <h3>Prevention</h3>
            <p>Seal entry points and provide ongoing protection</p>
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- Why Choose Us Section -->
  <div class="benefits-section">
    <div class="container">
      <h2>Why Choose Our Ant Control?</h2>
      
      <div class="benefits-grid">
        <div class="benefit-card">
          <mat-icon>target_on</mat-icon>
          <h3>Colony Elimination</h3>
          <p>We target the entire colony, including the queen, for complete elimination</p>
        </div>
        
        <div class="benefit-card">
          <mat-icon>eco</mat-icon>
          <h3>Safe Methods</h3>
          <p>Family and pet-safe treatments that are effective against ants</p>
        </div>
        
        <div class="benefit-card">
          <mat-icon>schedule</mat-icon>
          <h3>Fast Results</h3>
          <p>See significant reduction in ant activity within 24-48 hours</p>
        </div>
        
        <div class="benefit-card">
          <mat-icon>verified</mat-icon>
          <h3>Guaranteed Service</h3>
          <p>We guarantee our ant control treatments with follow-up service</p>
        </div>
      </div>
    </div>
  </div>

  <!-- CTA Section -->
  <div class="cta-section">
    <div class="container">
      <h2>Stop Ants in Their Tracks</h2>
      <p>Don't let ants take over your home. Our proven ant control methods eliminate colonies for good.</p>
      <div class="cta-buttons">
        <button mat-raised-button class="primary-cta" (click)="navigateToContact()">
          <mat-icon>pest_control</mat-icon>
          Schedule Ant Treatment
        </button>
        <button mat-button class="secondary-cta" (click)="callPhone()">
          <mat-icon>phone</mat-icon>
          Call for Free Quote
        </button>
      </div>
    </div>
  </div>
</div>

<app-footer></app-footer>